import React from 'react'

import queryString from 'query-string'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import { Button, Col, Row, Form, Portlet, Table, Divider } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant, ModalidadCalculosDeDepreciacionConstant } from 'constants/index'

import { ZrSwal, RounderUtil } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'
import * as DocumentoRelacionadoService from 'services/documentoRelacionado.service'

import * as Modals from './modals'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Detalles' }
]

// TODO > Improve
const DetalleAsiento = ({ match, history, location }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [cabeceraInfo, setCabeceraInfo] = React.useState(null)
  const [detalles, setDetalles] = React.useState([])
  const [detraccionInfo, setDetraccionInfo] = React.useState(null)
  const [flagSoloMonedaNacional, setFlagSoloMonedaNacional] = React.useState(false)

  const idFilaEdicionRef = React.useRef('')

  const [mostrarModalEditarAsignarDetraccion, setMostrarModalEditarAsignarDetraccion] = React.useState(false)
  const [mostrarModalEditarCuenta, setMostrarModalEditarCuenta] = React.useState(false)
  const [mostrarModalEditarMonedaMonto, setMostrarModalEditarMonedaMonto] = React.useState(false)
  const [mostrarModalEditarCentroCosto, setMostrarModalEditarCentroCosto] = React.useState(false)
  const [mostrarModalEditarDestino, setMostrarModalEditarDestino] = React.useState(false)

  const reloadTable = React.useCallback(() => {
    __zariContext.loader.open('Cargando detalles')
    AsientoContableService.getAsDetalle(match.params.idAsientoContable, flagSoloMonedaNacional)
      .then(({ data }) => {
        let { detalles, ...asientoData } = data
        setCabeceraInfo(asientoData)

        let sumaDebe = 0
        let sumaHaber = 0

        for (let i = 0; i < detalles.length; i++) {
          const element = detalles[i]
          if (element.tipo === 'DEB') {
            sumaDebe = RounderUtil.round(sumaDebe + element.monto)
          } else if (element.tipo === 'HAB') {
            sumaHaber = RounderUtil.round(sumaHaber + element.monto)
          }
        }
        setDetalles([
          ...detalles,
          ...[
            {
              _id: 'asdas',
              tipo: 'DEB-HAB',
              afectacion: '',
              moneda: 'TOTAL',
              montoDebe: sumaDebe,
              montoHaber: sumaHaber
            }
          ]
        ])
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext.loader, match.params.idAsientoContable, flagSoloMonedaNacional])

  const reloadInfoDetraccion = React.useCallback(() => {
    DocumentoRelacionadoService.obtenerxIdDocumentoPrincipalAsInfoDetraccion(match.params.idAsientoContable)
      .then(({ data }) => {
        if (data) {
          setDetraccionInfo(data)
        }
      })
      .catch(() => {
        __zariContext.snack('No se puedo obtener información de la detracción.')
      })
  }, [__zariContext, match.params.idAsientoContable])

  React.useEffect(() => {
    reloadTable()
    reloadInfoDetraccion()
  }, [reloadTable, reloadInfoDetraccion])

  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      tipo: 'info',
      mensaje: '¿Desea eliminar los registros?',
      showCerrar: true,
      onSuccess: () => {
        AsientoContableService.validarInventariosxId(match.params.idAsientoContable)
          .then(data => {
            if (data) {
              ZrSwal.showAlert({
                tipo: 'info',
                mensaje: 'El asiento proviene de inventarios, ¿Desea eliminar?',
                showCerrar: true,
                onSuccess: () => {
                  AsientoContableService.eliminarAsientoContable(match.params.idAsientoContable)
                    .then(() => {
                      history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`)
                      ZrSwal.showAlert({
                        tipo: 'success',
                        mensaje: 'Se han eliminado los registros.'
                      })
                    })
                    .catch(({ data: { error } }) => {
                      __zariContext.snack('error', error)
                    })
                }
              })
            } else {
              AsientoContableService.eliminarAsientoContable(match.params.idAsientoContable)
                .then(() => {
                  history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`)
                  ZrSwal.showAlert({
                    tipo: 'success',
                    mensaje: 'Se han eliminado los registros.'
                  })
                })
                .catch(({ data: { error } }) => {
                  __zariContext.snack('error', error)
                })
            }
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
          })
      }
    })
  }, [__zariContext, match.params.idAsientoContable, history])

  const clickContinuar = React.useCallback(() => {
    const { transaccion, ...restParams } = queryString.parse(location.search)

    if (transaccion) {
      const queryParams = queryString.stringify(restParams)

      history.push(`/${transaccion}?${queryParams}`)
    } else {
      history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`)
    }
  }, [history, location])

  const clickEditarCuenta = React.useCallback(({ _id }) => {
    idFilaEdicionRef.current = _id
    setMostrarModalEditarCuenta(true)
  }, [])

  const clickEditarMonedaMonto = React.useCallback(({ _id }) => {
    idFilaEdicionRef.current = _id
    setMostrarModalEditarMonedaMonto(true)
  }, [])

  const clickEditarCentroCosto = React.useCallback(({ _id }) => {
    idFilaEdicionRef.current = _id
    setMostrarModalEditarCentroCosto(true)
  }, [])

  const clickEditarDestino = React.useCallback(({ _id }) => {
    idFilaEdicionRef.current = _id
    setMostrarModalEditarDestino(true)
  }, [])

  const clickActualizarDetraccion = React.useCallback(() => {
    setMostrarModalEditarAsignarDetraccion(true)
  }, [])

  const clickAsignarDetraccion = React.useCallback(() => {
    setMostrarModalEditarAsignarDetraccion(true)
  }, [])

  const aplicaDestino = React.useCallback(
    cuentaContable => {
      if (__adminContext.modalidadCalculoDeDepreciacion !== ModalidadCalculosDeDepreciacionConstant.CLASE9) {
        return false
      }

      if (!cuentaContable) {
        return false
      }

      if (
        cuentaContable.startsWith('61') ||
        cuentaContable.startsWith('62') ||
        cuentaContable.startsWith('63') ||
        cuentaContable.startsWith('64') ||
        cuentaContable.startsWith('65') ||
        cuentaContable.startsWith('67')
      ) {
        return true
      } else {
        return false
      }
    },
    [__adminContext.modalidadCalculoDeDepreciacion]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Divider title='Cabecera de asiento' />
          {cabeceraInfo && (
            <Row className='zari-slim-form p-3'>
              <Col md={12}>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label text='ORIGEN' htmlFor='input-origen' md={4} />
                      <Col md={8}>
                        <Form.InputText
                          defaultValue={OrigenesContabilidadConstant.__dictionary[cabeceraInfo.origen].nombre}
                          id='input-origen'
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              {cabeceraInfo.origen === OrigenesContabilidadConstant.COMPRAS ||
              cabeceraInfo.origen === OrigenesContabilidadConstant.VENTAS ||
              cabeceraInfo.origen === OrigenesContabilidadConstant.COBRANZAS ||
              cabeceraInfo.origen === OrigenesContabilidadConstant.PAGOS ? (
                <Col md={12}>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label text='SOCIO' htmlFor='select-Socio' md={2} />
                        <Col md={10}>
                          <Form.InputText
                            defaultValue={`${cabeceraInfo.numeroDocumentoIdenficacionSocio} - ${cabeceraInfo.nombreSocio}`}
                            id='select-Socio'
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label text='SERIE' htmlFor='select-serie' md={4} />
                        <Col md={8}>
                          <Form.InputText
                            defaultValue={`${cabeceraInfo.serieDocumento} - ${cabeceraInfo.numeroDocumento}`}
                            id='select-serie'
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label text='GLOSA' htmlFor='select-glosa' md={4} />
                        <Col md={8}>
                          <Form.InputText defaultValue={cabeceraInfo.glosa} id='select-glosa' disabled />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              ) : null}
            </Row>
          )}
          {cabeceraInfo && cabeceraInfo.origen === OrigenesContabilidadConstant.COMPRAS ? (
            <>
              <Divider title='Detracción de asiento' />
              <Row className='mb-2'>
                <Col md={12}>
                  {!detraccionInfo ? (
                    <>
                      <Button tiny onClick={clickAsignarDetraccion}>
                        Asignar Detraccion
                      </Button>
                    </>
                  ) : (
                    <>
                      <Row className='zari-slim-form p-3'>
                        <Col md={12}>
                          <Row>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label text='TIPO' htmlFor='input-tipoDetraccion' md={4} />
                                <Col md={8}>
                                  <Form.InputText
                                    defaultValue={detraccionInfo.nombreTipoDetraccion || '--'}
                                    id='input-tipoDetraccion'
                                    disabled
                                  />
                                </Col>
                              </Form.Group>
                            </Col>
                            <Col md={2}>
                              <Button tiny onClick={clickActualizarDetraccion}>
                                Actualizar Detraccion
                              </Button>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label text='FECHA' htmlFor='input-fechaDetraccion' md={4} />
                                <Col md={8}>
                                  <Form.InputText
                                    defaultValue={detraccionInfo.fechaDocumento || '--'}
                                    id='input-fechaDetraccion'
                                    disabled
                                  />
                                </Col>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label text='NUM DOC' htmlFor='input-numeroDocumentoDetraccion' md={4} />
                                <Col md={8}>
                                  <Form.InputText
                                    defaultValue={detraccionInfo.numeroDocumento || '--'}
                                    id='input-numeroDocumentoDetraccion'
                                    disabled
                                  />
                                </Col>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label text='IMPORTE' htmlFor='input-importeDetraccion' md={4} />
                                <Col md={8}>
                                  <Form.InputText
                                    defaultValue={detraccionInfo.importeDetraccion || '--'}
                                    id='input-importeDetraccion'
                                    disabled
                                  />
                                </Col>
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
            </>
          ) : null}
          <Divider title='Detalle de asiento' />
          <Row className='zari-slim-form p-3'>
            <Col md={12}>
              <Form.Group>
                <Col md={12}>
                  <Form.Checkbox
                    id='checkbox-solomonedanacional'
                    name='checkbox-solomonedanacional'
                    label='Ver como moneda nacional'
                    checked={flagSoloMonedaNacional}
                    onClick={() => setFlagSoloMonedaNacional(prev => !prev)}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Table
            className='mb-2'
            headRows={[
              { label: 'CUENTA CONTABLE' },
              { label: 'CUENTA CONTABLE DESC' },
              { label: 'AFECTACION' },
              { label: 'MONEDA' },
              { label: 'DEBE' },
              { label: 'HABER' },
              { label: '' }
            ]}
            filas={detalles}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.cuentaContable}</Table.Cell>
                <Table.Cell>{row.descripcionCuentaContable}</Table.Cell>
                <Table.Cell>{row.afectacion || ''}</Table.Cell>
                <Table.Cell>{row.moneda || ''}</Table.Cell>
                <Table.Cell>
                  {row.tipo === 'DEB'
                    ? RounderUtil.round(row.monto)
                    : row.tipo === 'DEB-HAB'
                    ? RounderUtil.round(row.montoDebe)
                    : ''}
                </Table.Cell>
                <Table.Cell>
                  {row.tipo === 'HAB'
                    ? RounderUtil.round(row.monto)
                    : row.tipo === 'DEB-HAB'
                    ? RounderUtil.round(row.montoHaber)
                    : ''}
                </Table.Cell>
                <Table.Cell>
                  {row.tipo !== 'DEB-HAB' ? (
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item
                          key='editar-cuenta'
                          handleClose={handleClose}
                          onClick={e => clickEditarCuenta({ _id: row._id })}
                        >
                          Editar cuenta
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='editar-moneda-monto'
                          handleClose={handleClose}
                          onClick={e => clickEditarMonedaMonto({ _id: row._id })}
                        >
                          Editar moneda y monto
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='editar-centroCosto'
                          handleClose={handleClose}
                          onClick={e => clickEditarCentroCosto({ _id: row._id })}
                        >
                          Editar centro costo
                        </Table.Dropdown.Item>,
                        ...(aplicaDestino(row.cuentaContable) === true
                          ? [
                              <Table.Dropdown.Item
                                key='editar-destino'
                                handleClose={handleClose}
                                onClick={e => clickEditarDestino({ _id: row._id })}
                              >
                                Editar destino
                              </Table.Dropdown.Item>
                            ]
                          : [])
                      ]}
                    </Table.Dropdown>
                  ) : null}
                </Table.Cell>
              </Table.Row>
            )}
          />
          <Divider />
          <Row>
            <Col md={6}>
              <Button color='danger' onClick={clickEliminar}>
                Eliminar
              </Button>
            </Col>
            <Col md={6} className='text-right'>
              <Button onClick={clickContinuar} outline color='secondary'>
                Regresar
              </Button>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarModalEditarCuenta && (
        <Modals.EditarCuentaModal
          handleClose={() => setMostrarModalEditarCuenta(false)}
          show={mostrarModalEditarCuenta}
          idEdicion={idFilaEdicionRef.current}
          reloadTable={reloadTable}
        />
      )}
      {mostrarModalEditarMonedaMonto && (
        <Modals.EditarMonedaMontoModal
          handleClose={() => setMostrarModalEditarMonedaMonto(false)}
          show={mostrarModalEditarMonedaMonto}
          idEdicion={idFilaEdicionRef.current}
          reloadTable={reloadTable}
        />
      )}
      {mostrarModalEditarCentroCosto && (
        <Modals.EditarCentroCostoModal
          handleClose={() => setMostrarModalEditarCentroCosto(false)}
          show={mostrarModalEditarCentroCosto}
          idEdicion={idFilaEdicionRef.current}
          reloadTable={reloadTable}
        />
      )}
      {mostrarModalEditarDestino && (
        <Modals.EditarDestinoModal
          handleClose={() => setMostrarModalEditarDestino(false)}
          show={mostrarModalEditarDestino}
          idEdicion={idFilaEdicionRef.current}
          reloadTable={reloadTable}
        />
      )}
      {mostrarModalEditarAsignarDetraccion && (
        <Modals.EditarAsignarDetraccionModal
          handleClose={() => setMostrarModalEditarAsignarDetraccion(false)}
          show={mostrarModalEditarAsignarDetraccion}
          reloadInfoDetraccion={reloadInfoDetraccion}
          edicionData={detraccionInfo || {}}
          idDocumentoPrincipal={match.params.idAsientoContable}
        />
      )}
    </>
  )
}

export default DetalleAsiento
